import { Stack, Typography, useTheme } from '@mui/material';
import { InheritedIcon } from '@shared/custom-icons';
import React from 'react';
import { useCalculusTFunction } from '@retail/calculus/i18n';

export const InheritedConditionTag = () => {
  const t = useCalculusTFunction();
  const theme = useTheme();
  const palette = theme.vars.palette;
  return (
    <Stack direction="row" alignItems="center" gap={1}>
      <Typography color="textDisabled" variant="body2">
        {t('calculus.inherited')}
      </Typography>
      <InheritedIcon fill={palette.text.disabled} />
    </Stack>
  );
};
